import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { SlideTransition } from '../../../../../components/Transition/Transition';
import { whatsappUs } from '../../../../../utils/whatsapp';

const EnableTeamPageDialog = props => {
  const { intl, open, onClose, ...rest } = props;

  const onInquire = () => {
    whatsappUs({ text: '(APP) Would like to enable Profile+ team page with logo' });
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      {...rest}
      slots={{
        transition: SlideTransition
      }}>
      <DialogTitle>{intl.formatMessage({ id: 'enable-team-page-dialog-title' })}</DialogTitle>
      <DialogContent>{intl.formatMessage({ id: 'enable-team-page-dialog-content' })}</DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          {intl.formatMessage({ id: 'Cancel' })}
        </Button>
        <Button color="primary" onClick={onInquire}>
          {intl.formatMessage({ id: 'inquire' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default injectIntl(EnableTeamPageDialog);
